export enum AnalyticsSourceEnum {
    SHOP = 'shop',
    CP = 'cp',
}
